<template>
  <div class="CartPanel" >
    <!-- <b-button v-b-toggle.sidebar-right>Toggle Sidebar</b-button> -->
    <b-sidebar id="cartPanel" :title="'Shopping Cart ('+cartTotalqty+')'" right :backdrop-variant="variant" backdrop shadow>
			
		<b-container fluid v-if="$root.customer_info.user_id>0 && cartTotalqty>0" >
	
			<div class="card" v-if="walletData.total_blance>0">
				<b-row class="p-2" v-if="$root.cart.wallet_balance_applied==0">
						<b-col cols="8" sm="8" md="8" lg="8" class="font-sm">
						
							
							<!-- <b-form-group >
								 <b-form-checkbox  name="payment-type" value="cod"> Wallet Amount ({{$root.currency()+$root.tofixed(walletData.blance, 2)}})</b-form-checkbox>

								 
							</b-form-group> -->
							Redeem Wallet Amount ({{$root.currency()+$root.tofixed(walletData.total_blance, 2)}})
						</b-col>
						<b-col cols="4" sm="8" md="4" lg="4">
						<b-link class="font-sm" style="color:#c85df7;" @click="$root.applywallet(walletData.total_blance,'apply')">APPLY</b-link>
						</b-col>
				</b-row>
				<b-row class="p-2" v-else>
						<b-col cols="8" sm="8" md="8" lg="8" class="font-sm">
							Remove Redeem Amount
							<!-- <b-form-group >
								 <b-form-checkbox  name="payment-type" value="cod" v-model="$root.cart.wallet_balance_applied"> Remove Redeem Amount </b-form-checkbox>
							</b-form-group> -->
						</b-col>
						<b-col cols="4" sm="8" md="4" lg="4" class="font-sm">
						<b-link style="color:red" @click="$root.applywallet($root.customer_info['wallet'].total_blance,'remove')">REMOVE</b-link>
						</b-col>
				</b-row>
			
			</div>
		</b-container>			
		<b-container fluid v-if="cartTotalqty>0">			
			<div class="card" :key="item.id" v-for="item in cartItems">
				<!-- <header class="card-header">featured</header> -->
				<div class="card-body">
					<b-row>
						<b-col cols="3" sm="3" md="3" lg="3">
							<b-link v-if="item.product_slug==null" :href="'/product/'+item.product_id"> <b-img  rounded alt="" :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+item.image" class="pImg"></b-img></b-link>
							<b-link  v-else :href="'/'+item.product_slug"> <b-img  rounded alt="" :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+item.image" class="pImg"></b-img></b-link>
						</b-col>
						<b-col cols="7" sm="7" md="7" lg="7">
							
							<span class="pTitle">{{item.title}}</span>
							
							<cart-variant :cartItemslist="item" ></cart-variant>
							
							
						</b-col>
						<b-col cols="1" sm="2" md="1" lg="1">
							<b-link @click="$root.removeCart(item.id)"><i class="fa fa-trash" aria-hidden="true"></i></b-link>
						</b-col >
					</b-row>
					
				</div>
				<footer class="card-footer">
					
					<b-row>
							<b-col>
								<b-form-spinbutton id="sb-inline" size="sm" min="1" :max="item.stock_qty" step="1" :value="item.qty" @change="$root.updateCartqty(item, $event)" inline></b-form-spinbutton>
							</b-col>
							<b-col class="text-right" >
								<span v-if="item.special_price>0 && item.special_price!=null">
                             <del class="spCross">{{$root.currency()+$root.tofixed((item.price * item.qty), 2)}}</del> <small class="my-0" >{{$root.currency()+$root.tofixed((item.special_price * item.qty), 2)}}</small>
                           
							</span>
							<span v-else>
									<small class="my-0" >{{$root.currency()+$root.tofixed((item.price * item.qty), 2)}}</small>
							</span>

							<!--<small v-if="item.special_price>0 && item.special_price!=null">
							 {{$root.currency()+$root.tofixed((item.special_price * item.qty), 2)}}</small>
                            <small  v-else >{{$root.currency()+$root.tofixed((item.price * item.qty), 2)}}</small> -->
                        	</b-col>
						</b-row>
				</footer>
			</div>

			
		</b-container>
		
		<b-container fluid class="paymetDetails" v-if="cartTotalqty>0">
			<div class="pb-0 pt-2 px-3" >
				<p class="text-center paymetDetails-headPd">Payment Details</p>
               <b-row class="pt-2">
                        <b-col cols="9" > Subtotal ({{$root.cart.quantity}} item):</b-col>
                        <b-col class="text-right">{{$root.currency()+$root.tofixed($root.cart.subtotal, 2)}}</b-col>
                    </b-row>
                   
                    <b-row class="pt-2">
                        <b-col cols="9" class="pr-0">Shipping charge:<br><span class="paymetDetails-freeship">(Avail free shipping above purchase amount {{$root.currency()+$root.tofixed($root.free_shipping,2)}})</span></b-col>
                        <b-col class="text-right">{{$root.currency()+$root.tofixed($root.cart.shipping, 2)}}</b-col>
                    </b-row>
					<b-row class="pt-2" v-if="$root.cart.wallet_balance_applied>0">
						<b-col cols="7" class="pr-0">Wallet Balance (Applied):</b-col>
						<b-col class="text-right">-{{$root.currency()+$root.tofixed($root.cart.wallet_balance_applied, 2)}}</b-col>
					</b-row>
					<b-row class="pt-2" v-if="$root.cart.coupon_applied>0">
						<b-col cols="7" class="pr-0">Coupon (Applied):</b-col>
						<b-col class="text-right">-{{$root.currency()+$root.tofixed($root.cart.coupon.discount, 2)}}</b-col>
					</b-row>
                    <b-row class="pt-2 pb-2">
                        <b-col cols="9" class="pr-0">Total Price</b-col>
                        <b-col class="text-right">{{$root.currency()+$root.tofixed($root.cart.totalprice, 2)}}</b-col>
                    </b-row>
					<b-row class="pt-2 pb-2">
                        <b-col  class="pr-0"><coupon-panel></coupon-panel> </b-col>
                    </b-row>
            </div>

		
		</b-container>
		
		<b-container fluid  v-if="cartTotalqty==0">
			<div class="pb-0 pt-2 px-3" >
				<p class="text-center"><b-icon icon="handbag-fill" class="no-item-icon"></b-icon></p>
               <b-row class="py-3 text-center">
                 <b-col > Your Shopping Cart is empty</b-col>
              </b-row>
            </div>
	       	<b-row class="py-3">
	       		<b-col class="text-center" >
	       			 <b-button  variant="primary" @click="$router.push('/women-indian-wear')" class="btn-solid" style="border-radius:5px;"> Start Shopping <i class='fa fa-angle-right' style="font-size: 17px;"></i></b-button>
	       		</b-col>
	        </b-row>
		</b-container>
		
		
		

	
	
	
     
 
	
	
		<!-- <template #header="{ hide }">
       <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">header</strong>
        <b-button size="sm" @click="hide">Close</b-button>
       </div>
      </template>-->
      
	   <template #footer="{ hide }" v-if="cartTotalqty>0">
       <div class="d-flex footerBg align-items-center mb-2">
       	  <!-- <div class="d-flex footerBg bg-dark text-light align-items-center px-3 "> -->
       	<b-container fluid>
	       	<b-row>
	       		<b-col cols="6"	sm="6"	md="6"	lg="6"	xl="6">
	       			 <small class="mr-4">Total Price: </small><br/>
	       			 <!-- <span class="totalPr">{{$root.currency()+$root.tofixed(($root.cart.subtotal), 2)}}</span> -->
	       			 <span class="totalPr">{{$root.currency()+$root.tofixed(($root.cart.totalprice), 2)}}</span>
	       		</b-col>
	       		<b-col cols="6"	 sm="6"	md="6"	lg="6"	xl="6" class="checkoutBg checkoutProceed">
	       				<b-link class="btn-solid2 btn3" href="/checkout" @click="hide">Proceed to Buy</b-link>
	       			<!-- <b-button size="sm" @click="hide">Close</b-button>-->
	       		</b-col>
	        </b-row>
    	</b-container>
       </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
import CartVariant from "@/components/cartVariant.vue";
import CouponPanel from "@/components/couponPanel.vue";

import '@/assets/cartPanel.scss';
export default {
  name: 'CartPanel',
  components: {
  "cart-variant": CartVariant,
  "coupon-panel": CouponPanel,
  },
  props: {
    cartItems: { type: Array },
    cartData: { type: Object  },
    walletData: { type: Object  },
	cartTotalqty:Number,
  },
  mounted(){
  //this.inLodcard;
  },
  computed: {
    //
  },
  data() {
    return{
      modaldata_qty: 1,
	  variant:'dark',
	  cartHeader:'',
	  couponApply:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">



</style>
